import { Injectable } from '@angular/core';
import { Signaltag } from '../../models/trend-live-models/OPTag';
import { LdsClientService } from '../../providers/lds-client/lds-client.service';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { TagEntry } from '../../models/trend-live-models/TagEntry';
import * as moment from 'moment';
import { LdsTag } from '../../models/trend-live-models/LdsTag';
import { StarmsClientProvider } from '../../providers/starms-client/starms-client';
import { DEFAULT_TIME_FORMAT, TimeRange} from '../../models/trend-live-models/TimeRange';
import * as _ from 'lodash';
import { DemoProvider } from '../demo/demo';
import { TimeProvider } from '../time/time';


@Injectable()
export class TagsService {

  trendExplorerRequests: Subscription[] = [];

  constructor(private starms: StarmsClientProvider, private lds: LdsClientService, private demo: DemoProvider, private time: TimeProvider) { }
  /**
   * Fetch starms and lds data for a tag and return a merged result
   * @param tag tag to fetch
   * @param timeRange time range
   */
  fetch(tag: Signaltag, timeRange: TimeRange, resolution = { value: 'hourly', name: 'hourly' }, forTrendExplorer: boolean = false) {
    let starmsRequest;
    if(this.demo.demoMode){
      timeRange = this.time.getDemoModeParams(timeRange.interval.inDays)
      starmsRequest = this.starms
      .get(['signals/tags', tag.tagId], {
        filter: resolution.value,
        to: timeRange.to,
        from: timeRange.from
      })
      .pipe(
        // tap(res => {
        //   // tslint:disable-next-line: no-bitwise
        //   res.filter(x => (x.quality & 192) !== 192);
        // }),
        map(res => res.tagData.map(entry =>
          new TagEntry(entry.siteTime, entry.value, true)).filter(entry => entry !== undefined))
      )
    } else {
      timeRange.to =  moment(this.toTimezone(timeRange.to, tag.timeZone)).format(DEFAULT_TIME_FORMAT)
      timeRange.from = moment(this.toTimezone(timeRange.from, tag.timeZone)).format(DEFAULT_TIME_FORMAT)
      const newLocal = starmsRequest = this.starms
        .get(['signals/tags', tag.tagId, 'data'], {
          filter: resolution.value,
          to: timeRange.to,
          from: timeRange.from
        })
        .pipe(
          // tap(res => {
          //   // tslint:disable-next-line: no-bitwise
          //   res.filter(x => (x.quality & 192) !== 192);
          // }),
          map(res => res.map(entry => new TagEntry(entry.siteTime, entry.value, true)).filter(entry => entry !== undefined))
        );
    }
    
    const request = [
      starmsRequest
    ];

    // Wether the starms tag has an lds equivlent
    if (tag.ldsMeta && !this.demo.demoMode) {

      const timeRangeValue = timeRange.getLDSTime(tag.timeZone);
      let points = 0;
      if (moment.utc(timeRange.to) >= moment.utc(timeRangeValue.from)) {
        if (resolution.value != 'hourly') {
          points = Math.floor((moment.duration(timeRangeValue.to.diff(timeRangeValue.from)).asHours() * 6) + 2);
        } else {
          points = Math.floor((moment.duration(timeRangeValue.to.diff(timeRangeValue.from)).asHours()) + 2);
        }
      }

      const ldsFrom = moment(timeRangeValue.from).valueOf();
      const ldsTo = moment(timeRangeValue.to).valueOf();

      const now = new Date()
      const to = now.getTime()
      const from = now.setDate(now.getDate() - 1);

      if (points > 0) {
        request.push(this.lds.fetchTags(tag.ldsMeta.datasource, tag.ldsMeta.tag, to, from, points)
          .pipe(
            map(res => {
              if ((res as LdsTag).data[tag.ldsMeta.tag] as Array<any>) {
                return ((res as LdsTag).data[tag.ldsMeta.tag] as Array<any>)
                  .filter(entry => entry !== undefined)
                   
                  .map((entry, index) => {
                    return this.toTagEntry(entry, ldsFrom, ldsTo, points, index);
                  });
              } else {
                return [];
              }

            }
            )
          ));
      }

    }

    // Create the final result
    const result = new Observable<Array<TagEntry>>(subscriber => {
      // tslint:disable-next-line: deprecation

      // Send the requests
      // tslint:disable-next-line: deprecation
      let dataRequest = forkJoin(...request).subscribe((response: Array<Array<TagEntry>>) => {
        if (response[0].length > 1 && response[0][response[0].length - 1].value === null) {
          response[0].pop();
        }
        let mergedTags =
          (response[0] as TagEntry[]).map(entry => {
            if (entry.value) {
              entry.value = Number(entry.value.toFixed(4));
            }

            return entry;
          });

        // Merge responses
        if (response[1]) {
         let ldsEntries = response[1].sort((a, b) => a.timestamp - b.timestamp);
         mergedTags = mergedTags.filter(a => a.timestamp <= ldsEntries[0].timestamp);
          mergedTags.push(...ldsEntries.map(entry => {
            if (entry.value) {
              entry.value = Number(entry.value.toFixed(4));
            }

            return entry;
          }));
        }
        mergedTags.sort((a, b) => a.timestamp - b.timestamp);

        subscriber.next(mergedTags);
        subscriber.complete();
      }, error => {
        subscriber.error(error);
        subscriber.complete();
      });
      if (forTrendExplorer) {
        this.trendExplorerRequests.push(dataRequest);
      }

    });

    return result;

  }

  toTagEntry(entry: any, from: number, to: number, nrPoints: number, index: number) {
    let step = (to - from)/nrPoints
    index++;
    let finalTimestamp = moment.utc(moment(from + (index*step)).format('YYYY-MM-DD HH:mm:ss')).format();
    return new TagEntry(finalTimestamp, entry, true);
    
  }

  cancelTrendExplorerRequests() {
    for (let request of this.trendExplorerRequests) {
      request.unsubscribe();
    }
    this.trendExplorerRequests = [];
  }

    
  toTimezone(beforeDate, timezone) {
    var date = moment(beforeDate, DEFAULT_TIME_FORMAT).toDate();
    let jsTimezone = new Date(date).toLocaleString("en-US", {
      timeZone: timezone,
    });
    return new Date(jsTimezone).getTime();
  }
}



// WEBPACK FOOTER //
// ./src/providers/trend-live-services/tags.service.ts